import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import styles from './HeroCard.styles'
import intlPropTypes from '../../types/intlPropTypes'
import RegisterCTA from '../../components/RegisterCTA'

const PureHeroCard = ({ classes, intl, ctaOnClick, isEloThemeActive, ...props }) => (
  <Paper className={classes.container} {...props}>
    <Typography className={classes.heroCardHeader} component="h1">
      <FormattedHTMLMessage id="homeHeroTitle" />
    </Typography>
    <Typography
      className={classes.heroCardDescription}
      component="p"
      variant="h6"
    >
      <FormattedHTMLMessage id="homeHeroSubtitle" />
    </Typography>
    <RegisterCTA
      id="hero-desktop-cta-button"
      aria-label={intl.formatMessage({
        id: 'homeHeroCTAButtonAccessibleLabel'
      })}
      className={classes.heroButton}
      data-testid="hero-register-cta-button-desktop"
      label={intl.formatMessage({ id: 'homeHeroCTAButtonText' })}
      href={intl.formatMessage({ id: 'ctaButtonLinkDesktop' })}
      isEloThemeActive={isEloThemeActive}
      onClick={ctaOnClick}
      data-gtm-category-ga4="landing_hero"
      data-gtm-main-action-ga4="click"
      data-gtm-label-ga4={intl.formatMessage({ id: 'homeHeroCTAButtonText' })}
    />
  </Paper>
)

PureHeroCard.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string,
    heroButton: PropTypes.string,
    heroCardDescription: PropTypes.string,
    heroCardHeader: PropTypes.string,
    ctaOnClick: PropTypes.func
  }),
  intl: PropTypes.shape(intlPropTypes),
  isEloThemeActive: PropTypes.bool
}

const HeroCard = withStyles(styles)(injectIntl(PureHeroCard))

export default HeroCard
